export function formatRuntimeValue(hours: number): string {
  if (!Number.isFinite(hours) || hours < 0) return '—'

  if (hours < 1) {
    const totalMinutes = hours * 60
    const minutes = Math.floor(totalMinutes)
    const seconds = Math.round((totalMinutes - minutes) * 60)
    return `${minutes} min ${seconds} sec`
  }

  if (hours < 24) {
    const h = Math.floor(hours)
    const minutes = Math.round((hours - h) * 60)
    return `${h} h ${minutes} min`
  }

  const days = Math.floor(hours / 24)
  const remainingHours = Math.round((hours - days * 24) * 10) / 10
  return `${days} days ${remainingHours} h`
}

export function formatRuntimeDetailed(hours: number): string {
  if (hours < 0 || !Number.isFinite(hours)) return '0 min'

  if (hours >= 24) {
    const days = Math.floor(hours / 24)
    const remainingHours = Math.round((hours % 24) * 10) / 10
    return `${days}d ${remainingHours}h`
  }

  if (hours >= 1) {
    const h = Math.floor(hours)
    const minutes = Math.round((hours - h) * 60)
    return `${h}h ${minutes}m`
  }

  const totalMinutes = Math.round(hours * 60)
  if (totalMinutes >= 1) {
    const m = Math.floor(totalMinutes)
    const seconds = Math.round((hours * 3600) % 60)
    return `${m}m ${seconds}s`
  }

  return `${Math.round(hours * 3600)}s`
}

export function formatRuntimeShort(hours: number): string {
  if (hours < 0 || !Number.isFinite(hours)) return '0h'

  if (hours >= 24) {
    const days = Math.floor(hours / 24)
    const remainingHours = Math.round((hours % 24) * 10) / 10
    return `${days}d ${remainingHours}h`
  }

  if (hours >= 1) {
    return `${(Math.round(hours * 10) / 10)}h`
  }

  return `${Math.round(hours * 60)}m`
}
